'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _disclosure = require('./disclosure.js');

var _disclosure2 = _interopRequireDefault(_disclosure);

var _button = require('./global_components/button.js');

var _button2 = _interopRequireDefault(_button);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _table_component = require('./global_components/table_component.js');

var _table_component2 = _interopRequireDefault(_table_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactWaypoint = require('react-waypoint');

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _reactIntl = require('react-intl');

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('../../../packages/common-utilities/src/collection_utility');

var _fund_utility = require('../../../packages/common-utilities/src/fund_utility');

var _constants = require('../../../packages/common-utilities/src/constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var DetailedHoldingsCard = function (_React$Component) {
  _inherits(DetailedHoldingsCard, _React$Component);

  function DetailedHoldingsCard(props) {
    _classCallCheck(this, DetailedHoldingsCard);

    var _this = _possibleConstructorReturn(this, (DetailedHoldingsCard.__proto__ || Object.getPrototypeOf(DetailedHoldingsCard)).call(this, props));

    _this.renderHeaderRow = _this.renderHeaderRow.bind(_this);
    _this.renderHoldingsDataRows = _this.renderHoldingsDataRows.bind(_this);
    _this.renderRow = _this.renderRow.bind(_this);
    return _this;
  }

  _createClass(DetailedHoldingsCard, [{
    key: 'renderRow',
    value: function renderRow(data) {
      var rowWithTextLeftValue = function rowWithTextLeftValue(dataTestId, value) {
        return _react2.default.createElement(
          'td',
          { key: dataTestId, className: 'text-left', 'data-testid': dataTestId },
          value
        );
      };
      var rowWithTextLeftInnerHTML = function rowWithTextLeftInnerHTML(dataTestId, dataInnerHTML) {
        return _react2.default.createElement('td', { key: dataTestId, className: 'text-left', 'data-testid': dataTestId,
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(dataInnerHTML) } });
      };
      var rowWithTextRight = function rowWithTextRight(dataTestId, dataInnerHTML) {
        return _react2.default.createElement(
          'td',
          { key: dataTestId, className: 'text-right',
            'data-testid': dataTestId },
          dataInnerHTML
        );
      };

      var marketValue = (0, _ramda.isNil)(this.props.currencyCode) ? _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_currency_utility2.default.convertToCurrencyWithCommasAnd2DecimalsWithNoRounding(data.marketValue, 'USD')), numberFormat: this.props.numberFormat }) : _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(data.marketValue, 2)), numberFormat: this.props.numberFormat });

      var showMarketValueCurrency = _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).formattingRules, 'PORTFOLIO_HOLDING_MARKET_VALUE_CURRENCY');
      if (showMarketValueCurrency && data.currencyCode) {
        marketValue = _react2.default.createElement(
          'span',
          null,
          data.currencyCode,
          ' ',
          marketValue
        );
      }

      var dailyHoldingColumnMap = {
        "SYMBOL": rowWithTextLeftInnerHTML("holdings-symbol", data.securityTicker),
        "NAME": rowWithTextLeftInnerHTML("holdings-name", data.securityDescription),
        "SECURITY_IDENTIFIER": rowWithTextLeftInnerHTML("holdings-security-identifier", data.securityId),
        "CUSIP": rowWithTextLeftInnerHTML("holdings-security-identifier", data.securityCusip),
        "SECTOR": rowWithTextLeftInnerHTML("sector", data.sector),
        "PERCENTAGE_OF_NET_ASSETS": rowWithTextRight("holdings-net-asset-value", _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(data.netAssetValuePercent, 2)), numberFormat: this.props.numberFormat }),
          '%'
        )),
        "MARKET_VALUE_PERCENT": rowWithTextRight("holdings-market-value-percent", _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(data.marketValuePercent, 2)), numberFormat: this.props.numberFormat }),
          '%'
        )),
        "HOLD_PERC": rowWithTextRight("holdings-market-value-percent", _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(data.marketValuePercent, 1)), numberFormat: this.props.numberFormat }),
          '%'
        )),
        "MARKET_VALUE": rowWithTextRight("holdings-market-value", marketValue),
        "MARKET_VALUE_BASE": rowWithTextRight("holdings-market-value", (0, _ramda.isNil)(this.props.currencyCode) ? _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_currency_utility2.default.convertToCurrencyWithCommasAnd2DecimalsWithNoRounding(data.marketValueBase, 'USD')), numberFormat: this.props.numberFormat }) : _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(data.marketValueBase, 2)), numberFormat: this.props.numberFormat })),
        "ISIN": rowWithTextLeftInnerHTML("holdings-isin", data.securityIsin),
        "SECURITY_ISIN": rowWithTextLeftInnerHTML("holdings-security-isin", data.securityIsin),
        "SECURITY_TYPE": rowWithTextLeftInnerHTML("holdings-asset-class", data.securityType),
        "ASSET_CLASS": rowWithTextLeftInnerHTML("holdings-asset-class", data.securityType),
        "COUNTRY": rowWithTextLeftInnerHTML("holdings-country", data.country),
        "YIELD": rowWithTextRight("holdings-security-yield", _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(data.securityYield, 3)), numberFormat: this.props.numberFormat }),
          '%'
        )),
        "COUPON_RATE": rowWithTextRight("holdings-coupon-rate", _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(data.couponRate, 3)), numberFormat: this.props.numberFormat }),
          '%'
        )),
        "MATURITY_DT": rowWithTextLeftValue("holdings-finalLegalMaturityDate", this.getFormattedDate(data.finalLegalMaturityDate))
      };

      var visibleHoldings = this.getVisibleHoldings();
      return (0, _ramda.map)(function (column) {
        return dailyHoldingColumnMap[column];
      }, visibleHoldings);
    }
  }, {
    key: 'getFormattedDate',
    value: function getFormattedDate(date) {
      if ((0, _functional_utility.isNilOrEmpty)(date)) {
        return "-";
      }
      return _date_formatter2.default.getLocalFormattedDate(date);
    }
  }, {
    key: 'renderHeaderRow',
    value: function renderHeaderRow() {
      var _this2 = this;

      var headerRow = function headerRow(key, dataColumn, value) {
        var textRight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return _react2.default.createElement(
          'th',
          { key: key, className: 'tag ' + (textRight ? "text-right" : ""), onClick: _this2.changeSortFilter,
            'data-column': dataColumn },
          value
        );
      };
      var visibleTopHoldingsHeaderMap = {
        "SYMBOL": headerRow("Symbol", "symbol", _string_utility2.default.renderFormattedLabel("Symbol", 'pdp-portfolio-detailed-holdings-symbol-label')),
        "NAME": headerRow("Name", "name", _string_utility2.default.renderFormattedLabel("Name", 'pdp-portfolio-detailed-holdings-name-label')),
        "SECTOR": headerRow("Sector", "sector", _string_utility2.default.renderFormattedLabel("Sector", 'pdp-portfolio-sector')),
        "SECURITY_IDENTIFIER": headerRow("Security Identifier", "securityId", _string_utility2.default.renderFormattedLabel("Security Identifier", 'pdp-portfolio-detailed-holdings-securityidentifier-label')),
        "CUSIP": headerRow("Security Identifier", "securityCusip", _string_utility2.default.renderFormattedLabel("Security Identifier", 'pdp-portfolio-detailed-holdings-securityidentifier-label')),
        "PERCENTAGE_OF_NET_ASSETS": headerRow("% of Net Assets", "netAssets", _string_utility2.default.renderFormattedLabel("% of Net Assets", 'pdp-portfolio-detailed-holdings-percentageofnetassets-label'), true),
        "MARKET_VALUE_PERCENT": headerRow("Weight", "marketValuePercent", _string_utility2.default.renderFormattedLabel("Weight", 'pdp-portfolio-weight', { id: this.props.id }), true),
        "HOLD_PERC": headerRow("Weight", "marketValuePercent", _string_utility2.default.renderFormattedLabel("Weight", 'pdp-portfolio-weight', { id: this.props.id }), true),
        "MARKET_VALUE": headerRow("Market Value", "marketValue", _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'pdp-daily-holdings-market-value-col-header',
          defaultMessage: 'Market Value',
          values: {
            currencyCode: this.props.currencyCode,
            id: this.props.id
          } }), true),
        "MARKET_VALUE_BASE": headerRow("Market Value", "marketValueBase", _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'pdp-daily-holdings-market-value-col-header',
          defaultMessage: 'Market Value',
          values: {
            currencyCode: this.props.currencyCode,
            id: this.props.id
          } }), true),
        "ISIN": headerRow("ISIN", "securityIsin", _string_utility2.default.renderFormattedLabel("ISIN", 'pdp-isin-label', { role: this.props.role })),
        "SECURITY_ISIN": headerRow("Security ISIN", "securityIsin", _string_utility2.default.renderFormattedLabel("Security Identifier", 'pdp-security-isin-label')),
        "SECURITY_TYPE": headerRow("Asset class", "securityType", _string_utility2.default.renderFormattedLabel("Security type", 'pdp-portfolio-detailed-holdings-security-type-label')),
        "ASSET_CLASS": headerRow("Asset class", "assetClass", _string_utility2.default.renderFormattedLabel("Asset class", 'pdp-asset-class-label', { role: this.props.role })),
        "COUNTRY": headerRow("Country", "country", _string_utility2.default.renderFormattedLabel("Country", 'pdp-portfolio-holdings-country')),
        "YIELD": headerRow("Yield", "yield", _string_utility2.default.renderFormattedLabel("Yield", 'pdp-portfolio-detailed-holdings-yield-label'), true),
        "COUPON_RATE": headerRow("Coupon rate", "couponRate", _string_utility2.default.renderFormattedLabel("Coupon rate", 'pdp-portfolio-detailed-holdings-coupon-rate-label'), true),
        "MATURITY_DT": headerRow("Maturity date", "maturityDate", _string_utility2.default.renderFormattedLabel("Maturity date", 'pdp-portfolio-detailed-holdings-maturity-date-label'))
      };

      var visibleHoldings = this.getVisibleHoldings();
      return (0, _ramda.map)(function (column) {
        return visibleTopHoldingsHeaderMap[column];
      }, visibleHoldings);
    }
  }, {
    key: 'getVisibleHoldings',
    value: function getVisibleHoldings() {
      var visibleHoldings = this.props.visibleTopHoldings;

      if (this.props.isProxyHolding) {
        visibleHoldings = this.props.visibleProxyHoldings;
      } else if (this.props.isUnderlyingHolding) {
        visibleHoldings = this.props.visibleUnderlyingHoldings;
      }

      return visibleHoldings;
    }
  }, {
    key: 'renderHoldingsDataRows',
    value: function renderHoldingsDataRows() {
      var _this3 = this;

      return mapIndexed(function (data, i) {
        return _react2.default.createElement(
          'tr',
          { key: i, 'data-testid': 'holdings-row', className: 'padding-vertical-5 category row-divider' },
          _this3.renderRow(data)
        );
      }, this.props.data);
    }
  }, {
    key: 'getServiceURL',
    value: function getServiceURL(controller) {
      return encodeURI(this.props.gaiaRedirectUrl + '/' + controller + '?type=dailyETFHoldings' + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&fundType=' + this.props.fundTypeCode + '&locale=' + _string_utility2.default.generateLocale() + '&isUnderlyingHolding=' + this.props.isUnderlyingHolding + '&isProxyHolding=' + this.props.isProxyHolding);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.data.length === 0) {
        return null;
      }

      var excelServiceURL = void 0;
      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'SHOW_TOP_HOLDING_DOWNLOAD')) {
        var documentTag = _constants2.default.getFdTagConstants();
        var _props = this.props,
            content = _props.content,
            cusip = _props.cusip,
            isAEM = _props.isAEM;

        var filteredDocs = (0, _fund_utility.getDocumentsFromContentByDocType)(content, cusip, isAEM, documentTag.FULL_PORTFOLIO_LISTING);

        if (!(0, _functional_utility.isNilOrEmpty)(filteredDocs)) {
          excelServiceURL = filteredDocs[0].docURL;
        }
      } else {
        var controller = this.props.downloadHoldingsAsPDF ? "pdf" : "excel";
        excelServiceURL = this.getServiceURL(controller);
      }

      var headerTitle = _string_utility2.default.renderFormattedLabel("Top Holdings", this.props.headerId, {
        numberOfHoldings: this.props.data.length,
        role: this.props.role
      });
      var ariaLabel = "";
      if (!(0, _ramda.isNil)(headerTitle)) {
        var title = (0, _functional_utility.isNilOrEmpty)(headerTitle.key) ? headerTitle : _string_utility2.default.getLocalizedString(this.props.intl, headerTitle.props.defaultMessage, headerTitle.key);
        ariaLabel = 'Read more about ' + title;
      }

      var headerTitleId = void 0,
          pdfButtonText = void 0,
          xlsButtonText = void 0;
      if (this.props.id === "proxyHoldingsCard") {
        headerTitleId = "proxyHoldingsCard";
        pdfButtonText = "pdp-daily-proxy-holdings-download-button-pdf";
        xlsButtonText = "pdp-daily-proxy-holdings-download-button-xls";
      } else if (this.props.isUnderlyingHolding) {
        headerTitleId = "underlyingHoldingCard";
        pdfButtonText = "pdp-daily-holdings-download-button-pdf";
        xlsButtonText = "pdp-daily-holdings-download-button-xls";
      } else {
        headerTitleId = "etfHoldingsCard";
        pdfButtonText = "pdp-daily-holdings-download-button-pdf";
        xlsButtonText = "pdp-daily-holdings-download-button-xls";
      }

      return _react2.default.createElement(
        'div',
        { className: 'portfolio-child-card' },
        _react2.default.createElement(_reactWaypoint2.default, { topOffset: '35%', bottomOffset: '80%', onEnter: this.props.activeCardHandler.bind(this, headerTitleId) }),
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: headerTitle,
            headerTitleId: headerTitleId,
            headerTitleLabel: !(0, _ramda.isNil)(this.props.isFullWidth) && this.props.isFullWidth ? "portfolio-full-width-header" : "portfolio-child-header",
            breakpoint: this.props.breakpoint,
            headerLabel: _date_formatter2.default.getEffectiveDateHeader(this.props.id, this.props.effectiveDate, this.props.country, this.props.role, this.props.breakpoint),
            dataTest: headerTitleId
          },
          _react2.default.createElement(_table_component2.default, {
            tableHeaders: this.renderHeaderRow(),
            tableRows: this.renderHoldingsDataRows(),
            tableBodyTest: 'portfolio-all-holdings-body',
            activeTab: this.props.activeTab,
            breakpoint: this.props.breakpoint
          }),
          (0, _ramda.isNil)(this.props.showDownloadButton) || this.props.showDownloadButton && (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'DETAILED_HOLDINGS_EXCEL_AND_PDF_DOWNLOAD') || _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'DETAILED_PROXY_HOLDINGS_EXCEL_AND_PDF_DOWNLOAD')) && _react2.default.createElement(
            'span',
            null,
            ' ',
            _react2.default.createElement(_button2.default, {
              role: this.props.role,
              dataTest: "download-data",
              downloadURL: this.getServiceURL("pdf"),
              dataTestLink: this.props.id + '-pdf-download',
              text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: pdfButtonText, defaultMessage: 'DOWNLOAD ALL HOLDINGS (PDF)' }),
              additionalClassName: "mobile-full-width",
              callBack: function callBack() {
                return _tracking_utility.TrackingUtility.trackEvent({
                  "eventCategory": "pdp",
                  "eventAction": "portfolio",
                  "eventLabel": _tracking_utility.TrackingUtility.getEventAction("downloadHoldings")
                });
              }
            }),
            _react2.default.createElement(_button2.default, {
              role: this.props.role,
              dataTest: "download-data",
              downloadURL: this.getServiceURL("excel"),
              dataTestLink: this.props.id + '-excel-download',
              text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: xlsButtonText, defaultMessage: 'DOWNLOAD ALL HOLDINGS (XLS)' }),
              additionalClassName: "mobile-full-width margin-left-10",
              callBack: function callBack() {
                return _tracking_utility.TrackingUtility.trackEvent({
                  "eventCategory": "pdp",
                  "eventAction": "portfolio",
                  "eventLabel": _tracking_utility.TrackingUtility.getEventAction("downloadHoldings")
                });
              }
            })
          ),
          (0, _ramda.isNil)(this.props.showDownloadButton) || this.props.showDownloadButton && !_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'DETAILED_HOLDINGS_EXCEL_AND_PDF_DOWNLOAD') && !_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'DETAILED_PROXY_HOLDINGS_EXCEL_AND_PDF_DOWNLOAD') && _react2.default.createElement(_button2.default, {
            role: this.props.role,
            dataTest: "download-data",
            downloadURL: excelServiceURL,
            dataTestLink: this.props.id + '-excel-download',
            text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.isUnderlyingHolding ? "pdp-underlying-holdings-download-button" : "pdp-daily-holdings-download-button", defaultMessage: 'DOWNLOAD ALL HOLDINGS' }),
            additionalClassName: "mobile-full-width",
            callBack: function callBack() {
              return _tracking_utility.TrackingUtility.trackEvent({
                "eventCategory": "pdp",
                "eventAction": "portfolio",
                "eventLabel": _tracking_utility.TrackingUtility.getEventAction("downloadHoldings")
              });
            }
          }),
          _react2.default.createElement(_disclosure2.default, { disclosureText: this.props.disclosureText, placementId: this.props.placementId, arialabel: ariaLabel })
        )
      );
    }
  }]);

  return DetailedHoldingsCard;
}(_react2.default.Component);

exports.default = DetailedHoldingsCard;